import ReducerRegistry from '../base/redux/ReducerRegistry';
import { ADD_REACTION_BUFFER, FLUSH_REACTION_BUFFER, SET_REACTION_QUEUE, SHOW_SOUNDS_NOTIFICATION, TOGGLE_REACTIONS_VISIBLE } from './actionTypes';
/**
 * Returns initial state for reactions' part of Redux store.
 *
 * @private
 * @returns {IReactionsState}
 */
function _getInitialState() {
    return {
        visible: false,
        buffer: [],
        timeoutID: null,
        queue: [],
        notificationDisplayed: false
    };
}
ReducerRegistry.register('features/reactions', (state = _getInitialState(), action) => {
    var _a, _b, _c;
    switch (action.type) {
        case TOGGLE_REACTIONS_VISIBLE:
            return Object.assign(Object.assign({}, state), { visible: !state.visible });
        case ADD_REACTION_BUFFER:
            return Object.assign(Object.assign({}, state), { buffer: (_a = action.buffer) !== null && _a !== void 0 ? _a : [], timeoutID: (_b = action.timeoutID) !== null && _b !== void 0 ? _b : null });
        case FLUSH_REACTION_BUFFER:
            return Object.assign(Object.assign({}, state), { buffer: [], timeoutID: null });
        case SET_REACTION_QUEUE: {
            return Object.assign(Object.assign({}, state), { queue: (_c = action.queue) !== null && _c !== void 0 ? _c : [] });
        }
        case SHOW_SOUNDS_NOTIFICATION: {
            return Object.assign(Object.assign({}, state), { notificationDisplayed: true });
        }
    }
    return state;
});
